(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cheeky-video-laughs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cheeky-video-controller')) {
  class CheekyVideoController extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const root = this.closest('.shopify-section');
      const section = root?.querySelector('.ck-laughs');
      if (!section) return;
      const videos = [...section.querySelectorAll('.ck-laughs__video')];
      const visible = new Set(), userPaused = new Set(), states = new Map();
      const update = video => {
        const screen = video.closest('.ck-laughs__screen');
        screen.setAttribute('aria-label', video.paused ? screen.dataset.playLabel : screen.dataset.pauseLabel);
        screen.setAttribute('aria-pressed', String(!video.paused));
      };
      const cover = (video, reason) => {
        const card = video.closest('.ck-laughs__card');
        const poster = card.querySelector('.ck-laughs__poster');
        const status = card.querySelector('.ck-laughs__error');
        if (poster) poster.hidden = false;
        if (reason) {
          video.hidden = true;
          card.dataset.videoState = reason;
          status.textContent = reason === 'error' ? status.dataset.retryText : status.dataset.playText;
          status.hidden = false;
        }
        update(video);
      };
      const recover = (video, error) => {
        if (error?.name === 'AbortError') { update(video); return; }
        if (error?.name === 'NotAllowedError') { cover(video, 'blocked'); return; }
        const state = states.get(video);
        if (state.index + 1 < state.sources.length) {
          state.index++;
          video.src = state.sources[state.index];
          video.load();
          play(video);
        } else cover(video, 'error');
      };
      const play = video => {
        if (document.hidden || userPaused.has(video)) return;
        const state = states.get(video);
        if (!state.sources.length) { cover(video, 'error'); return; }
        video.muted = true;
        video.defaultMuted = true;
        if (!video.getAttribute('src')) { video.src = state.sources[state.index]; video.load(); }
        video.hidden = false;
        const attemptedSource = video.src;
        const attempt = video.play();
        attempt?.catch(error => { if (video.src === attemptedSource) recover(video, error); });
      };
      videos.forEach(video => {
        const card = video.closest('.ck-laughs__card');
        const screen = card.querySelector('.ck-laughs__screen');
        states.set(video, {index:0, sources:[video.dataset.videoUrl,video.dataset.fallbackUrl].filter(Boolean)});
        const toggle = () => {
          if (video.paused) {
            userPaused.delete(video);
            if (card.dataset.videoState === 'error') {
              states.get(video).index = 0;
              video.removeAttribute('src');
            }
            play(video);
          } else { userPaused.add(video); video.pause(); }
        };
        video.muted = true;
        video.defaultMuted = true;
        update(video);
        screen.addEventListener('click', toggle, {signal});
        screen.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); }
        }, {signal});
        video.addEventListener('playing', () => {
          const poster = card.querySelector('.ck-laughs__poster');
          video.hidden = false;
          if (poster) poster.hidden = true;
          card.querySelector('.ck-laughs__error').hidden = true;
          card.dataset.videoState = 'playing';
          update(video);
        }, {signal});
        video.addEventListener('waiting', () => cover(video), {signal});
        video.addEventListener('pause', () => update(video), {signal});
        video.addEventListener('volumechange', () => { if (!video.muted) video.muted = true; }, {signal});
        video.addEventListener('error', () => { if (video.error) recover(video, video.error); }, {signal});
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
          const video = entry.target.querySelector('video');
          if (entry.isIntersecting && entry.intersectionRatio >= 0.25) { visible.add(video); play(video); }
          else { visible.delete(video); video.pause(); }
        }), {threshold:[0,0.25]});
        videos.forEach(video => this.observer.observe(video.closest('.ck-laughs__screen')));
      } else videos.forEach(video => { visible.add(video); play(video); });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) videos.forEach(video => video.pause());
        else visible.forEach(play);
      }, {signal});
      const header = document.querySelector('.ck-head');
      const purchaseBar = document.querySelector('.ck-sticky');
      const fit = () => {
        const viewport = window.visualViewport?.height || window.innerHeight;
        const headHeight = header?.getBoundingClientRect().height || 0;
        const purchaseHeight = purchaseBar?.getBoundingClientRect().height || 0;
        const height = Math.max(96, Math.min(520, viewport - headHeight - purchaseHeight - 112));
        section.style.setProperty('--ck-video-fit-height', `${Math.floor(height)}px`);
      };
      fit();
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(fit);
        [header,purchaseBar].filter(Boolean).forEach(element => this.resize.observe(element));
      }
      window.addEventListener('resize', fit, {signal});
      window.visualViewport?.addEventListener('resize', fit, {signal});
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.resize?.disconnect(); }
  }
  customElements.define('cheeky-video-controller', CheekyVideoController);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cheekynook-tracking"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cn-tracking__form').forEach(form => {
    form.addEventListener('submit',event => {
      const number = form.elements.nums.value.trim();
      if (!number) return;
      event.preventDefault();
      window.location.assign('https://t.17track.net/en#nums=' + encodeURIComponent(number));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
